import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { FoundersDream } from "@/components/hilltop/FoundersDream";

export const Route = createFileRoute("/_public/founders-dream")({
  component: FoundersDreamPage,
});

function FoundersDreamPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FoundersDream />
      <Footer />
    </div>
  );
}
